import React from 'react';
import qs from 'query-string';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import CommitFromItem from './form-item';
import { QuestionItem } from '../../types';
import { createForm } from 'rc-form';
import connect from '../../store/connect';
import './index.less';
import { GdImage } from '@gaodun.com/gui-pc';

export type CommitFormItemProps = {
    list: QuestionItem[];
    showConfigExt?: any;
    disabled?: boolean;
    onClick?: (val?) => void;
} & RouteComponentProps &
    Props;

const timeout = 1500;
class CommitForm extends React.Component<CommitFormItemProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            visible: false,
            formItemList: [],
            current: 0,
            formAnswers: {},
            ended: false,
            submitLoading: false,
            isShowStart: false,
            isShowForm: false,
            isShowProgress: false,
        };
    }
    componentDidMount() {
        const { loginStatus } = this.props;
        if (!loginStatus.accessToken) {
            this.props.updataBindPhoneVisit(true);
            window['observer'].once('loginSuccess', () => {
                this.props.getQuestionAnswers && this.props.getQuestionAnswers();
                this.initFormInfo();
            });
            return;
        }
        this.initFormInfo();
    }

    initFormInfo = async () => {
        this.setState(
            {
                loading: false,
                formItemList: this.props.list,
            },
            () => {
                setTimeout(() => {
                    this.hadStart();
                }, timeout);
            }
        );
    };
    hadStart = () => {
        this.scrollToAnchor(`.evaluation-form-bd .evaluation-form-item-start`);
        this.setState(
            {
                isShowStart: true,
            },
            () => {
                this.hadSuccess();
            }
        );
    };
    hadSuccess = () => {
        if (!this.props.list || !this.props.list.length) {
            this.setState(
                {
                    ended: true,
                },
                () => {
                    setTimeout(() => {
                        this.scrollToAnchor(`.evaluation-form-bd .evaluation-form-item-0`);
                    }, timeout);
                }
            );
            setTimeout(() => {
                this.handleSubmit();
            }, timeout);
        } else {
            setTimeout(() => {
                this.setState(
                    {
                        isShowForm: true,
                    },
                    () => {
                        setTimeout(() => {
                            this.setState({
                                isShowProgress: true,
                            });
                        }, timeout);
                    }
                );
            }, timeout);
        }
    };

    handleSubmit = async () => {
        let { formAnswers } = this.state;
        let answers = {};
        for (let i in formAnswers) {
            if (formAnswers.hasOwnProperty(i) && formAnswers[i]) {
                try {
                    if (typeof formAnswers[i] == 'object') {
                        answers[i] = formAnswers[i].map(i => i.seq);
                    } else {
                        answers[i] = formAnswers[i];
                    }
                    // answers[i] = typeof formAnswers[i] == 'object' ? formAnswers[i] : JSON.stringify(formAnswers[i])
                } catch (error) {
                    answers[i] = formAnswers[i];
                }
            }
        }
        setTimeout(() => {
            this.props.onClick && this.props.onClick(answers);
        }, timeout);
    };

    scrollToAnchor = anchorName => {
        if (anchorName) {
            let anchorElement = document.querySelector(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            }
        }
    };
    handleChange = (name, val, index) => {
        let { formItemList, formAnswers, current } = this.state;
        formAnswers[name] = val;
        this.setState(
            {
                formAnswers,
            },
            () => {
                // 正在编辑当前显示的最后一题 && 非最后一题
                if (index == current && current !== formItemList.length - 1) {
                    this.setState(
                        {
                            current: index + 1,
                        },
                        () => {
                            setTimeout(() => {
                                this.scrollToAnchor(`.evaluation-form-bd .evaluation-form-item-${index + 1}`);
                            }, 10);
                        }
                    );
                }
                // 最后一题编辑
                else if (index == formItemList.length - 1) {
                    this.setState(
                        {
                            ended: true,
                        },
                        () => {
                            this.scrollToAnchor(`.evaluation-form-bd .evaluation-form-item-${formItemList.length}`);
                            setTimeout(() => {
                                this.handleSubmit();
                            }, timeout);
                        }
                    );
                }
            }
        );
    };

    render() {
        const { isShowProgress, submitLoading, ended, formItemList, current, formAnswers, isShowStart, isShowForm } = this.state;
        console.log(isShowProgress, 'currentcurrent');
        let { showConfigExt } = this.props;
        return (
            <div className="evaluation-form-box">
                {!!isShowProgress && (
                    <div className="evaluation-form-progress">
                        <div className="evaluation-form-progress-ct" style={{ width: `${((current + 1) / formItemList.length) * 100}%` }}>
                            {current + 1}/{formItemList.length}
                        </div>
                    </div>
                )}
                <div className="evaluation-form-bd">
                    <div className={`commit-form-item evaluation-form-item-x`}>
                        <div className="commit-form-item-hd">
                            <GdImage
                                className="robot"
                                src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202112/27/7d9c8_20211227135558.gif"
                            />
                        </div>
                        <div className="commit-form-item-ct">
                            <div className="commit-form-item-q">{showConfigExt.startText || '通过本次测试，将为您分配专属助教'}</div>
                        </div>
                    </div>
                    <div className={`commit-form-item evaluation-form-item-start`}>
                        <div
                            className="commit-form-item-ct commit-form-item-ct-start"
                            style={{ display: !!isShowStart ? 'block' : 'none' }}
                        >
                            <div className="commit-form-item-q">开始</div>
                        </div>
                    </div>
                    {!!isShowForm &&
                        formItemList.map((item, index) => {
                            return (
                                index <= current && (
                                    <CommitFromItem
                                        className={`evaluation-form-item-${index}`}
                                        key={index}
                                        name={item.name}
                                        label={item.content}
                                        disabled={submitLoading}
                                        question={item}
                                        value={formAnswers[item.name]}
                                        onChange={val => this.handleChange(item.name, val, index)}
                                    />
                                )
                            );
                        })}
                    {ended && (
                        <div className={`commit-form-item ${`evaluation-form-item-${formItemList.length}`}`}>
                            <div className="commit-form-item-hd">
                                <GdImage
                                    className="robot"
                                    src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202112/27/7d9c8_20211227135558.gif"
                                />
                            </div>
                            <div className="commit-form-item-ct">
                                <div className="commit-form-item-q">{showConfigExt.endText || '正在为您分配专属助教，请稍等...'}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
export default createForm()(connect(withRouter(CommitForm)));
